import AllergensToggleButton from './AllergensToggleButton';

export default {
  AllergensToggleButton,
};
